import { request } from "../../api/api"

export const signInApi = (data) => {
    return request.post('login/', data)
}

export const forgotPasswordApi = (data) => {
    return request.post('forgetPassword/', data)
}

export const otpVerify = (data) => {
    return request.post('otpVerify/', data)
}

export const newPasswordApi = (data) => {
    return request.post('updatePassword/', data)
}

export const verifyuser = (data) => {
    return request.post('verifyUser/', data)
}


// login 2 step verify
export const login2StepApi = (data) => {
    return request.post('/verify2StepMobileOTP/', data)
}

// login mfa verify
export const loginMfaApi = (data) => {
    return request.post('/validateMFA/', data)
}

// resend OTP
export const resendOtpApi = (data) => {
    return request.post('/app/resendOTPForRegister', data)
}
export const changePasswordApi = (id, data) => {
    return request.put(`/changePassword/${id}/`, data)
}

// unlock account api 
export const  unlockAccount = (data) => {
    return request.post('/unlockAccount/', data)
}
export const getCaptcha =()=>{
    return request.get('/user/getCaptcha/')
}
export const verifyCaptcha = (data) => {
    return request.post('/user/validateCaptcha/', data)
}
 